import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginWarranty } from "@/Calls/callWarrantyAuth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2, ShieldCheck } from "lucide-react";

export default function WarrantyLoginPage() {
    const navigate = useNavigate();
    const [email,    setEmail]    = useState("");
    const [password, setPassword] = useState("");
    const [loading,  setLoading]  = useState(false);
    const [error,    setError]    = useState<string | null>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const res = await loginWarranty(email, password);
            if (res.data.ok) {
                navigate("/warranty/dashboard");
            } else {
                setError(res.data.message ?? "Login failed");
            }
        } catch (err: any) {
            const msg = err.response?.data?.message;
            if (msg === "Account pending approval") {
                setError("Your account is pending approval. Please contact IDSCRM support.");
            } else {
                setError(msg ?? "Invalid credentials");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-900 to-slate-900 px-4">
            <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md space-y-6">
                <div className="text-center space-y-2">
                    <div className="flex justify-center">
                        <ShieldCheck className="h-10 w-10 text-purple-600" />
                    </div>
                    <h1 className="text-2xl font-semibold">Warranty Provider Portal</h1>
                    <p className="text-muted-foreground text-sm">Sign in to access your dashboard</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="text-sm font-medium">Email</label>
                        <Input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="company@example.com"
                            className="mt-1"
                            required
                        />
                    </div>
                    <div>
                        <label className="text-sm font-medium">Password</label>
                        <Input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                            className="mt-1"
                            required
                        />
                    </div>

                    {error && <p className="text-sm text-red-500">{error}</p>}

                    <Button type="submit" className="w-full bg-purple-600 hover:bg-purple-700 text-white" disabled={loading}>
                        {loading && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
                        Sign In
                    </Button>
                </form>
            </div>
        </div>
    );
}
